const DEV_AUTH_API_URL = "http://localhost:8086";

function normalizeBaseUrl(url) {
	return String(url || "").trim().replace(/\/$/, "");
}

function getAuthBaseUrl() {
	const configured = normalizeBaseUrl(process.env.REACT_APP_AUTH_URL || "");

	if (!configured) {
		return process.env.NODE_ENV === "production" ? "" : DEV_AUTH_API_URL;
	}

	if (/^:\d+$/.test(configured)) {
		return `http://localhost${configured}`;
	}

	if (/^localhost:\d+$/i.test(configured)) {
		return `http://${configured}`;
	}

	return configured;
}

export const AUTH_BASE_URL = getAuthBaseUrl();

async function fetchJson(url, options = {}) {
	const response = await fetch(url, options);

	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}

	return { response, payload };
}

export async function login(email, password) {
  const { response, payload } = await fetchJson(
    `${AUTH_BASE_URL}/auth/login`,
    {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    }
  );

  if (!response.ok) {
    throw new Error(payload?.error || "Failed to login");
  }

  return payload;
}

export async function getSession() {
  const { response, payload } = await fetchJson(
    `${AUTH_BASE_URL}/auth/session`,
    { method: "GET", credentials: "include" }
  );

  if (response.status === 401) return null;

  if (!response.ok) {
    throw new Error(payload?.error || "Failed to load session");
  }

  return payload;
}

export async function logout() {
  const { response, payload } = await fetchJson(
    `${AUTH_BASE_URL}/auth/logout`,
    { method: "POST", credentials: "include" }
  );

  if (!response.ok) {
    throw new Error(payload?.error || "Failed to logout");
  }

  return payload;
}

export async function getAdmins() {
  const { response, payload } = await fetchJson(
    `${AUTH_BASE_URL}/auth/getAdmins`,
    { method: "GET", credentials: "include" }
  );

  if (!response.ok) {
    throw new Error(payload?.error || "Failed to load admins");
  }

  return payload;
}

export async function impersonate(client) {
  const response = await fetch(`${AUTH_BASE_URL}/auth/impersonation/start`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-Impersonation-Request": "true",
    },
    body: JSON.stringify({
      user_id: client.user_id,
      organization_id: client.organization_id,
      reason: "Investigate booking issue",
    }),
  });

  if (!response.ok) {
    throw new Error("Failed to start impersonation");
  }

  return await response.json();
}

export async function stopImpersonation() {
  const { response, payload } = await fetchJson(
    `${AUTH_BASE_URL}/auth/impersonation/stop`,
    {
      method: "POST",
      credentials: "include",
      headers: {
        "X-Impersonation-Request": "true",
      },
    }
  );

  if (!response.ok) {
    throw new Error(payload?.error || "Failed to stop impersonation");
  }

  return payload;
}